import { breakpoints } from '@assets/global-style/global-style'
import icon_lock from '@assets/images/icon-lock.svg'
import styled from 'styled-components'

const Container = styled.div`
  width: calc(100% - 10px);
  margin-top: -20px;
  margin-left: 5px;
  transition: all 0.5s;
  background: rgba(0, 0, 0, 0.08);
  padding: 15px 20px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  @media screen and (min-width: ${breakpoints.sm}) {
    /* max-width: 240px; */
    margin-top: 0px;
    margin-left: 15px;
  }
`
const WarningMessage = styled.p`
  width: 100%;
  color: var(--dark-blue);
  font-size: 14px;
  font-weight: bold;

  @media screen and (min-width: ${breakpoints.sm}) {
  }
`
const SuccessMessage = styled(WarningMessage)`
  width: 150px;
  color: var(--dark-blue);
  font-size: 14px;
  font-weight: normal;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  &::before {
    content: url(${icon_lock});
    margin: 0px 0 10px 0px;
  }
  @media screen and (min-width: ${breakpoints.sm}) {
    flex-direction: column-reverse;
    font-size: 16px;
    padding: 0;
    width: 180px;
    &::before {
      margin: 10px 0 0px 0px;
    }
  }
`
const List = styled.ul`
  padding: 10px 20px 0px 20px;
  margin: 0;
  width: 100%;
  &:empty {
    display: none;
  }
`
const ListItem = styled.li`
  color: var(--darkblue);
  position: relative;
  display: flex;
  margin-bottom: 5px;
  font-size: 14px;
  transition: all 0.5s;
  &:before {
    transition: all 0.5s;
    content: '';
    display: block;
    position: absolute;
    left: -10px;
    top: 3px;
    height: 5px;
    width: 5px;
    border: 5px solid;
    border-color: transparent transparent transparent var(--orange);
  }
  @media screen and (min-width: ${breakpoints.sm}) {
    /* &:before {
      border-color: transparent transparent transparent var(--dark-blue);
    } */
  }
`

export { Container, WarningMessage, SuccessMessage, List, ListItem }
